var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaferGambling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.023 8.462a.75.75 0 00-1.061.016l-4.309 4.444-1.615-1.666-.056-.053a.75.75 0 00-1.07 1.04l.05.057 1.974 2.037.077.071a1 1 0 001.36-.071l4.665-4.815a.75.75 0 00-.015-1.06z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.991 10.61l.009-.46V6.03a1 1 0 00-.652-.938l-8-2.963a1.002 1.002 0 00-.696 0l-8 2.963A1 1 0 003 6.029v4.12l.009.46c.04 1.071.223 2.133.542 3.158l.104.322a12.163 12.163 0 006.88 7.307l1.152.475.076.027c.154.047.32.047.474 0l.076-.027 1.153-.474c3.243-1.335 5.747-4.001 6.879-7.308l.104-.322a12.16 12.16 0 00.542-3.158zM12 3.598l7.5 2.778v3.772c0 .941-.125 1.878-.37 2.785l-.112.386a10.664 10.664 0 01-5.85 6.573l-.272.117-.896.368-.896-.368a10.663 10.663 0 01-6.029-6.407l-.093-.283a10.662 10.662 0 01-.482-3.17V6.376L12 3.599z",
    fill: "currentColor"
  })));
}
SvgSaferGambling.displayName = 'SaferGambling';
export default SvgSaferGambling;